import { toThousandths, type ChartPoint } from '@platform/design-system';
import type { ProductRanking, TopProduct } from './performance.ts';

export type SliceDisplay = {
  readonly units: (units: number) => string;
  readonly amount: (amount: string) => string;
};

const nameOf = (product: TopProduct, products: readonly TopProduct[]): string =>
  products.filter((other) => other.productName === product.productName).length > 1
    ? `${product.productName} (${product.sku})`
    : product.productName;

const MEASURES: Readonly<
  Record<
    ProductRanking,
    (product: TopProduct, display: SliceDisplay) => Pick<ChartPoint, 'value' | 'display'>
  >
> = {
  units: (product, display) => ({ value: product.units, display: display.units(product.units) }),
  sales: (product, display) => ({
    value: toThousandths(product.sales),
    display: display.amount(product.sales),
  }),
};

export const topProductSlicesOf = (
  products: readonly TopProduct[],
  rankedBy: ProductRanking,
  display: SliceDisplay,
): readonly ChartPoint[] =>
  products.map((product) => ({
    key: product.variantId,
    label: nameOf(product, products),
    ...MEASURES[rankedBy](product, display),
  }));
